"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraBadge = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
require("../styles/eura-badge.css");
const EuraBadgeRed = (props) => react_1.default.createElement(antd_1.Badge, Object.assign({ className: 'eura-badge eura-badge__red' }, props));
const EuraBadgeGrey = (props) => react_1.default.createElement(antd_1.Badge, Object.assign({ className: 'eura-badge eura-badge__grey' }, props));
const EuraBadge = (props) => react_1.default.createElement(antd_1.Badge, Object.assign({ className: 'eura-badge' }, props));
exports.EuraBadge = EuraBadge;
exports.EuraBadge.Red = EuraBadgeRed;
exports.EuraBadge.Grey = EuraBadgeGrey;
